import type { ComponentProps } from 'react';

import type { PageGrid, PageGridItem } from 'corgi/common/components/PageGrid';

import { GRID_ITEM_BOX_SHADOW } from '@constants/style';

export const commonGridStyles: ComponentProps<typeof PageGrid> = {
  alignItems: 'center',
  justifyContent: 'center',
  alignContent: 'flex-start',
  m: 'sp_0',
  px: ['sp_4', 'sp_0'],

  // TODO: Apply gutter to all direct children
  // gutter: ['sp_8', 'sp_12', null, 'sp_16'],

  // Define top and bottom separately, so it can be overridden correctly.
  pt: ['sp_16', 'sp_20', 'sp_24', 'sp_32'],
  pb: ['sp_16', 'sp_20', 'sp_24', 'sp_32'],
  backgroundColor: 'sys.neutral.background.weak',
  boxShadow: GRID_ITEM_BOX_SHADOW,
};

export const cardStyles: ComponentProps<typeof PageGridItem> = {
  py: ['sp_16', null, null, 'sp_20'],
  px: ['sp_12', 'sp_16', null, 'sp_24'],
  backgroundColor: 'sys.neutral.background.default',
  borderRadius: 'medium',
  width: [1, 3 / 4, '400px', '448px'],
  maxWidth: ['432px', null, '448px'],
};

export const firstSectionStyles = {
  mr: ['sp_0', null, 'sp_12', 'sp_16'],
  ...cardStyles,
};

export const secondSectionStyles = {
  ml: ['sp_0', null, 'sp_12', 'sp_16'],
  mt: ['sp_4', null, 'sp_0'],
  ...cardStyles,
};
